module.exports = __webpack_public_path__ + "static/CityCouncil-e1f853789b67b5083a3664165a706361.png";